import Bugsnag from '@bugsnag/js';
import { typeOf } from '@ember/utils';

export default {
  error() {
    if (Bugsnag?.isStarted()) {
      let args = Array.prototype.slice.call(arguments);
      let err = isError(args[0]) ? args[0] : new Error(safeStringify(args));
      Bugsnag.notify(err);
    }

    // eslint-disable-next-line no-console
    console.error.apply(this, arguments);
  },

  errorWithDetails(error, details) {
    const err = isError(error) ? error : new Error(safeStringify(error));

    if (Bugsnag?.isStarted()) {
      Bugsnag.notify(err, (event) => {
        event.addMetadata('details', details);
      });
    }

    console.error(error, details);
  },

  warn() {
    if (Bugsnag?.isStarted()) {
      Bugsnag.notify(arguments);
    }

    // eslint-disable-next-line no-console
    console.warn.apply(this, arguments);
  },
  info() {
    // eslint-disable-next-line no-console
    console.info.apply(this, arguments);
  },
  debug() {
    // eslint-disable-next-line no-console
    console.debug.apply(this, arguments);
  },
};

let isError = function (object) {
  return typeOf(object) === 'error';
};

const safeStringify = (obj) => {
  if (obj == null) {
    return '(null)';
  }

  try {
    const seen = new WeakSet();
    return JSON
      ? JSON.stringify(obj, (key, value) => {
          if (isError(value)) {
            // The Error object doesn't have any enumerable properties, so we need
            // to handle it ourselves.
            //
            // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/JSON/stringify
            return {
              name: value.name,
              message: value.message,
              stack: value.stack,
              ...Object.getOwnPropertyNames(value).reduce((acc, prop) => {
                acc[prop] = value[prop];
                return acc;
              }, {}),
            };
          } else if (typeof value === 'object' && value !== null) {
            if (seen.has(value)) {
              return undefined; // Skip circular references
            }
            seen.add(value);
          }

          return value;
        })
      : object.toString();
  } catch (e) {
    // If JSON.stringify fails, we fall back to the default toString method
    console.error('Error in JSON.stringify', e);
    return obj.toString();
  }
};
